import { Component, OnInit, Directive, Input } from '@angular/core';

@Component({
  selector: 'ant-button-groupp',
  template:`<div class="ant-btn-group" [ngClass]="{'ant-btn-group-sm': size === 'small' , 'ant-btn-group-lg': size === 'large'

}">
    <ng-content></ng-content>
</div>`,
  styles: [`::ng-deep .ant-btn-group {
  position: relative;
  display: inline-block;
  font-size: 0px;
}
::ng-deep .ant-btn-group > .ant-btn {
  position: relative;
  z-index: 1;
}
::ng-deep .ant-btn-group > .ant-btn:hover,
::ng-deep .ant-btn-group > .ant-btn:focus,
::ng-deep .ant-btn-group > .ant-btn:active,
::ng-deep .ant-btn-group > .ant-btn.active {
  z-index: 2;
}
::ng-deep .ant-btn-group > .ant-btn:disabled {
  z-index: 0;
}
::ng-deep .ant-btn-group-lg > .ant-btn {
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
}
::ng-deep .ant-btn-group-sm > .ant-btn {
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
  height: 22px;
}
::ng-deep .ant-btn-group-sm > .ant-btn > .anticon {
  font-size: 12px;
}
::ng-deep .ant-btn-group ant-button .ant-btn + ant-button .ant-btn,
ant-button .ant-btn + ::ng-deep .ant-btn-group,
::ng-deep .ant-btn-group ant-button + .ant-btn,
::ng-deep .ant-btn-group ant-button + ::ng-deep .ant-btn-group ant-button {
  margin-left: -1px;
}
::ng-deep .ant-btn-group ant-button {
  box-sizing: border-box;
}
::ng-deep .ant-btn-group ant-button:not(:first-child):not(:last-child) .ant-btn {
  border-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ant-button:first-child:not(:last-child) > .ant-btn {
  margin-left: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ant-button:last-child:not(:first-child) > .ant-btn {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding-left: 8px;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group {
  float: left;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:not(:first-child):not(:last-child) .ant-btn {
  border-radius: 0;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:last-child:not(:first-child) .ant-btn:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding-left: 8px;
}
@keyframes buttonEffect {
  to {
    opacity: 0;
    top: -6px;
    left: -6px;
    bottom: -6px;
    right: -6px;
    border-width: 6px;
  }
}
`]
})
export class ButtonGrouppComponent {
  @Input() public size = '';
  constructor() { }
}
